import { getSpaUrlsWhitelist } from './spa-urls-whitelist';

// Checks if passed url is supporting SPA transitions
export function isSpaPage(url, venomEnv, edmundsEnv) {
  const spaUrlsWhitelist = getSpaUrlsWhitelist(venomEnv, edmundsEnv);
  return spaUrlsWhitelist.some(rule => rule.test(url));
}
